import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StatistikIgangvaerende } from '../../models/StatistikIgangvaerende';
import { StatistikIgangvaerendeFakturaModal } from '../statistik-igangvaerende-kunde-faktura-modal/statistik-igangvaerende-faktura-modal';
import { StatistikIgangvaerendeKunde } from '../../models/StatistikIgangvaerendeKunde';
import { StatistikIgangvaerendeKundeDatoModal } from '../statistik-igangvaerende-kunde-dato-modal/statistik-igangvaerende-kunde-dato-modal';
import { StatistikService } from '../../statistik.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { StatistikIgangvaerendeKundeFaktura } from '../../models/StatistikIgangvaerendeKundeFaktura';
import {
    StatistikIgangvaerendeRetforventettabModal
} from '../statistik-igangvaerende-retforventettab-modal/statistik-igangvaerende-retforventettab-modal';
import { ClientCasesDetailsContainerComponent } from '../../../shared/client-cases-details/client-cases-details.container';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-statistik-igangvaerende-kunde-modal',
    templateUrl: './statistik-igangvaerende-kunde-modal.html',
    styleUrls: ['./statistik-igangvaerende-kunde-modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikIgangvaerendeKundeModal implements OnInit {
    @Input() kunde: StatistikIgangvaerende;
    @Input() date: string;
    statistikIgangvaerendeKunde$: Observable<StatistikIgangvaerendeKunde[]>;
    private reloadSubject = new BehaviorSubject<void>(undefined);

    constructor(
        private activeModal: NgbActiveModal,
        private modalService: NgbModal,
        private statistikService: StatistikService
    ) { }

    ngOnInit() {
        this.statistikIgangvaerendeKunde$ = this.reloadSubject.pipe(
            switchMap(() =>
                this.statistikService.getIgangvaerendeKunde(this.date, this.kunde.kid)
            )
        );
        this.reloadSubject.next();
    }

    onDismiss() {
        this.activeModal.close();
    }

    async openDateModal(sag: StatistikIgangvaerendeKunde, forventetTabValue: string) {
        const numberValue = +forventetTabValue;

        if (sag.forventedTab !== numberValue) {
            const dateModal = this.modalService.open(StatistikIgangvaerendeKundeDatoModal);
            dateModal.componentInstance.selectedsagid = sag.sagId;
            dateModal.componentInstance.newForventetTab = numberValue;
            dateModal.componentInstance.selectedDate = this.date;
            dateModal.result.then(() => this.reloadSubject.next());
        }
    }

    openFakturaModal(kunde: StatistikIgangvaerende, sagsid: number) {
        const observableIgangvaerendeKundeFaktura: Observable<any> =
            this.statistikService.getIgangvaerendeKundeFaktura(this.date, kunde.kid, sagsid);

        const igangvaerendeKundeFakturaSubscription = observableIgangvaerendeKundeFaktura.subscribe(
            (data: StatistikIgangvaerendeKundeFaktura) => {
                const fakturaModal = this.modalService.open(StatistikIgangvaerendeFakturaModal);
                fakturaModal.componentInstance.statistikIgangvaerendeKundeFaktura = data;
                fakturaModal.componentInstance.kunde = kunde;
                fakturaModal.componentInstance.date = this.date;

                fakturaModal.result.finally(() => {
                    igangvaerendeKundeFakturaSubscription.unsubscribe();
                });
            },
        );
    }

    async openSagskortModal(kid: number) {
        const modal = this.modalService.open(ClientCasesDetailsContainerComponent, { size: 'lg' });
        modal.componentInstance.kid = kid;
        modal.componentInstance.til = this.date;
    }

    async openRetForventetTabModal(sagsid: number) {
        const forventedtabModal = this.modalService.open(StatistikIgangvaerendeRetforventettabModal);
        forventedtabModal.componentInstance.sagsid = sagsid;
    }
}
